import { downgradeInjectable } from '@angular/upgrade/static';
import * as angular from 'angular';
import { AccountService } from '@go-modules/services/account/account.service';
export { AccountService as NgxAccountService } from '@go-modules/services/account/account.service';

export const ngxAccountServiceModule = angular.module('ngxAccountServiceModule', [])
	.factory('ngxAccountService', downgradeInjectable(AccountService))
	.name;
